export default __webpack_public_path__ + "c809d913.png";